import { Navigate, Route, Routes } from "react-router-dom";
import AuthForm from "../screens/AuthForm/AuthForm";
import Wallet from "../screens/CustomerWallet/WalletDashboard";
import Dashboard from "../screens/Dashboard/Dashboard";
import Security from "../screens/Dashboard/Security";
import Enterprise from "../screens/Enterprise/Enterprise";
import KycManagement from "../screens/KYC/KYCManagement";
import Merchant from "../screens/Merchant/Merchant";
import SettingMain from "../screens/Setting/SettingMain";
import Transactions from "../screens/TransactionsPackage/Transactions";
import UserManagement from "../screens/UserManagmentPackage/UserManagement";
import WalletOperations from "../screens/WalllManagmentPackage/WalletOperations";
import AdminLayout from "./AdminLayout";
import PrivateRoutes from "./PrivateRoutes";
import RequireAuth from "./RequireAuth";

export const NavigationRoutes = () => {
  return (
    <Routes>
      {/* ADMIN DASHBOARD - All under /admin */}
      <Route element={<PrivateRoutes />}>
        <Route path="/admin" element={<AdminLayout />}>
          <Route element={<RequireAuth allowedRoles={["1"]} />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="security" element={<Security />} />
            <Route path="settings" element={<SettingMain />} />
          </Route>

          <Route element={<RequireAuth allowedRoles={["1", "3"]} />}>
            <Route path="transactions" element={<Transactions />} />
          </Route>

          <Route element={<RequireAuth allowedRoles={["1", "4", "5"]} />}>
            <Route path="user-management" element={<UserManagement />} />
            <Route path="kyc-management" element={<KycManagement />} />
            <Route path="wallet-operations" element={<WalletOperations />} />
          </Route>

          <Route element={<RequireAuth allowedRoles={["2"]} />}>
            <Route path="bulkTransactions" element={<Enterprise />} />
          </Route>

          <Route element={<RequireAuth allowedRoles={["3"]} />}>
            <Route path="receivePayment" element={<Merchant />} />
          </Route>
        </Route>
        <Route element={<RequireAuth allowedRoles={["6"]} />}>
          <Route path="walletDashboard" element={<Wallet />} />
        </Route>
      </Route>

      {/* LOGIN and AUTH */}
      <Route path="/login" element={<AuthForm />} />
      <Route path="/authForm" element={<AuthForm />} />

      {/* DEFAULT REDIRECTS and FALLBACK */}
      <Route index element={<Navigate to="/login" replace />} />
    </Routes>
  );
};
